import { render, staticRenderFns } from "./RecipientTemplate.vue?vue&type=template&id=d833c820&scoped=true&"
import script from "./RecipientTemplate.vue?vue&type=script&lang=js&"
export * from "./RecipientTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d833c820",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d833c820')) {
      api.createRecord('d833c820', component.options)
    } else {
      api.reload('d833c820', component.options)
    }
    module.hot.accept("./RecipientTemplate.vue?vue&type=template&id=d833c820&scoped=true&", function () {
      api.rerender('d833c820', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/RecipientTemplate.vue"
export default component.exports